import { render, staticRenderFns } from "./loan_volume_chart.vue?vue&type=template&id=bce4e4f2&"
import script from "./loan_volume_chart.vue?vue&type=script&lang=js&"
export * from "./loan_volume_chart.vue?vue&type=script&lang=js&"
import style0 from "./loan_volume_chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports